export enum AppType {
  Reps = 'reps',
  Talent = 'talent',
  Casting = 'casting',
  Onboarding = 'onboarding',
  Ula = 'ula',
  Admin = 'admin',
}

export enum AuditionType {
  IN_PERSON = 'IN_PERSON',
  ONLINE_VIRTUAL = 'ONLINE_VIRTUAL',
  BOTH = 'BOTH',
  NOT_SURE = 'NOT_SURE',
}

export enum AuditionTypeDisplayType {
  Options = 'options',
  Display = 'display',
  DisplayWithAudition = 'displayWithAudition',
}

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

export type AccountTimeZoneType = {
  standardName: string;
  abbreviation: string;
};
